$(document).on('turbolinks:load', function () {
  // Bootstrap 5のJavaScriptが読み込まれるまで待つ
  if (typeof bootstrap === 'undefined') {
    console.warn('Bootstrap 5 JavaScript is not loaded yet');
    return;
  }

  // モーダルの初期化
  var modals = [].slice.call(document.querySelectorAll('.modal'))
  modals.map(function (modal) {
    return new bootstrap.Modal(modal)
  })

  $('#modal-icon-league').on('click', function() {
    $('#league-modal').modal('show');
  });
  $('#registration-promotion-modal-btn').on('click', function() {
    $('#registration-promotion-modal').modal('show');
  });
  $('#match-new-modal-icon').on('click', function() {
    $('#match-new-modal').modal('show');
  });
})